<template>
  <div class="hy-info" :class="thisStatus == 0 ? 'baoming':''">
    <div class="info-bannerbox">
      <van-swipe class="my-swipe" :autoplay="5000">
        <van-swipe-item v-for="(item, index) in postsData.banner" :key="index">
          <img v-lazy="item.pic_url" width="100%" @click="goPath(item.app_url.rule)" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="info-cont" v-if="postsData.conference != ''">
      <div class="info-topTitle" v-if="postsData.conference">
        <div class="title">
          <h5>{{postsData.conference.name}}</h5>
          <span class="info_icon" v-if="postsData.conference.type == 1">会议</span>
          <span class="info_icon" v-else-if="postsData.conference.type == 2">沙龙</span>
          <span class="info_icon" v-else="postsData.conference.type == 3">活动</span>
        </div>
        <div class="infotimes infotimes_width_label_content" v-if="postsData.conference.guide_company != ''"> 
            <div class="label">
              <span class="iconfont">&#xe6bb;</span>
              <span>指导单位：</span>
            </div>
            <div class="content">
              <div v-for="(i, index) in postsData.conference.guide_company?.split(' ')" :key="index">{{ i }}</div>
            </div>
        </div>
        <div class="infotimes infotimes_width_label_content" v-if="postsData.conference.organizers != ''"> 
            <div class="label">
              <span class="iconfont">&#xe6bb;</span>
              <span>主办单位：</span>
            </div>
            <div class="content">
              <div v-for="(i, index) in postsData.conference.organizers?.split(' ')" :key="index">{{ i }}</div>
            </div>
        </div>
        <div class="infotimes" v-if="id == '5664' && postsData.conference.company != ''">
          <span class="iconfont">&#xe6bb;</span>协办单位：{{postsData.conference.company}}
        </div>
        <div class="infotimes infotimes_width_label_content" v-if=" id != '5664' && postsData.conference.company != ''">
            <div class="label">
              <span class="iconfont">&#xe6bb;</span>
              <span>承办单位：</span>
            </div>
            <div class="content">
              <div v-for="(i, index) in postsData.conference.company?.split(' ')" :key="index">{{ i }}</div>
            </div>
        </div>
        <div class="infotimes" v-if="postsData.conference.show_date_format == 0">
          <span class="iconfont">&#xe67f;</span>时间：{{postsData.conference.start_time,'Y-M-D h:m'|formatDates}}至{{postsData.conference.end_time,'Y-M-D h:m'|formatDates}}
        </div>
        <div class="infotimes" v-else>
          <span class="iconfont">&#xe67f;</span>时间：{{postsData.conference.start_time,'Y-M-D'|formatDates}}至{{postsData.conference.end_time,'Y-M-D'|formatDates}}
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe64d;</span>地点：{{postsData.conference.region}}{{postsData.conference.specific_address}}
        </div>
        <!--灰色 icon_black   黄色 icon_yellow 蓝色  icon_blue-->
        <div class="infoBtnBox icon_yellow" v-if="postsData.conference.status_str == '报名中'">
          <span class="infoBtn">报名中</span>
          <p v-if="postsData.conference.is_show_residue == 1">剩余名额{{postsData.conference.count}}人</p>
        </div>
        <div class="infoBtnBox icon_yellow" v-else-if="postsData.conference.status_str == '会议中'">
          <span class="infoBtn">会议中</span>
          <p>{{postsData.conference.sold_count}}人参加会议</p>
        </div>
        <div class="infoBtnBox icon_yellow" v-else-if="postsData.conference.status_str == '已结束'">
          <span class="infoBtn">已结束</span>
          <p>{{postsData.conference.sold_count}}人参加会议</p>
        </div>
        <div class="infoBtnBox icon_black" v-else-if="postsData.conference.status_str == '报名截止'">
          <span class="infoBtn">报名截止</span>
          <p>{{postsData.conference.sold_count}}人参加会议</p>
        </div>
        <div class="infoBtnBox icon_black" v-else-if="postsData.conference.status_str == '未到报名时间'">
          <span class="infoBtn">未到报名时间</span>
        </div>
        <div class="infoBtnBox icon_black" v-else>
          <span class="infoBtn">{{postsData.conference.status_str}}</span>
       </div>
        <div class="baidu_map">
          <baidu-map v-bind:style="mapStyle" class="bm-view" ak="4VWHfbyLFc9o7BGgyaR1FvzM3r5IjhQH" :center="center" :zoom="zoom" :scroll-wheel-zoom="true" @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
            <bm-view style="width: 100%; height:250px;"></bm-view>
            <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
              <bm-info-window :offset="{width: 0, height: 0}" :show="true" :auto-pan=true :close-on-click="false">地址：{{postsData.conference.specific_address}} <template v-if="id == '24088'">（吉林省延边朝鲜族自治州延吉市友谊路66号） </template></bm-info-window>
            </bm-marker> <!-- 红点 -->
          </baidu-map>
        </div>
      </div>
      <div class="info-listbox">
        <van-tabs v-model="lmActive" class="yiji" v-if="postsData.column.length >0 ">
          <van-tab :title="itembox.title" v-for="(itembox, i) in postsData.column" >
            <van-tabs v-model="active" scrollspy sticky v-if="itembox.child.length > 0" class="erji">
              <van-tab v-for="(item, index) in itembox.child" :title="item.title" >
                <!--单页-->
                <div class="info_item info_textinfobox" v-if="item.type == 1">
                  <h5>{{item.title}}</h5>
                  <div class="info_item_text" v-html="item.content">
                  </div>
                </div>
                <!--资料-->
                <div class="info_item info_downlist" v-else-if="item.type == 10">
                  <h5>{{item.title}}</h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items,index2) in item.list_info" :key="index2">
                        <div class="imgbox">
                          <img src="../../assets/images/index/hy_word.png" alt v-if="items.type == 'word'" />
                          <img src="../../assets/images/index/hy_pdf.png" alt v-else-if="items.type == 'pdf'" />
                          <img src="../../assets/images/index/hy_ppt.png" alt v-else-if="items.type == 'ppt'" />
                          <img src="../../assets/images/index/hy_zip.png" alt v-else />
                        </div>
                        <div class="textbox">
                          <h5>{{items.title}}</h5>
                          <p>{{(items.size/1024).toFixed(2)}}MB</p>
                        </div>
                        <div class="hy_zlbtn" v-if="items.is_buy">
                          <a href="javascript:;" @click="downfile(items.id)">
                            <span class="iconfont">&#xe703;</span> 下载
                          </a>
                        </div>
                      </li>
                    </ul>
                    <!--  <a href="javascript:;" class="getMore" v-if="filebox.getFilebtn" @click="getMoreDown(index)">
    加载更多
    <span class="iconfont get_more_icon_all">&#xe699;</span>
      </a>
    <a href="javascript:;" class="getMore" v-else>
    没有了
      </a>-->
                  </div>
                </div>
                <!--视频-->
                   <div class="info_item info_video" v-else-if="item.type == 11">
                  <h5>{{item.title}}</h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items, index) in item.list_info" :key="index" @click="videoPlay(items.id)">
                        <div class="imgbox">
                          <img :src="item.video_cover_url" alt />
                          <span class="iconfont icon">&#xe696;</span>
                        </div>
                        <div class="textbox" v-if="items.info">
                          <h5>
                            <a href="/">{{items.title}}</a>
                          </h5>
                          <p class="time">{{items.create_time,'Y-M-D h:m'|formatDates}} 时长：{{items.duration}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!--资讯-->
                <div class="info_item info_list" v-else-if="item.type == 9">
                  <h5>{{item.title}}</h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items,index3) in item.list_info" :key="index3">
                        <div class="imgbox">
                          <img :src="items.uploadImgId_url" alt @click="goHref2(i,index,index3)" />
                        </div>
                        <div class="textbox">
                          <h5 @click="goHref2(i,index,index3)">
                            {{items.name}}
                          </h5>
                          <p class="time">{{items.author}} {{items.release_time,'Y-M-D h:m'|formatDates}}</p>
                          <div class="hy_bottom">
                            <p class="num">{{items.click_volume}}人已看</p>
                            <a href="javascript:;" class="hy_zanBtn active iconfont" @click="newsDigg2(items.id,i,index,index3)">
                              &#xe607;
                              <span>{{items.count}}</span>
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!--嘉宾-->
                <div class="info_item info_jiabin" v-else-if="item.type == 5">
                  <h5>
                    {{item.title}}
                    <router-link class="link" :to="{ name: 'peopleList', params: { id: id }}">查看更多 ></router-link>
                  </h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items,index3) in item.list_info" :key="index3" @click="goPeopleInfo2(i,index,index3)">
                        <template v-if="index3 < 6">
                          <router-link class="links" :to="{ name: 'peopleInfo', params: { id: items.id }}">
                            <div class="imgbox">
                              <img :src="items.head_img" alt />
                            </div>
                            <h5 class="hy_name">{{items.name}}</h5>
                            <p class="hy_type">{{items.domain}}</p>
                            <p class="hy_jigou" v-html="items.description"></p>
                          </router-link>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
            <template v-else>
              <!--单页-->
              <div class="info_item info_textinfobox" v-if="itembox.type == 1">
                <h5>{{itembox.title}}</h5>
                   <div class="info_item_text" v-html="itembox.content">
                  </div>
                </div>
                <!--资料-->
                <div class="info_item info_downlist" v-else-if="itembox.type == 10">
                  <h5>{{itembox.title}}</h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items,index2) in itembox.list_info" :key="index2">
                        <div class="imgbox">
                          <img src="../../assets/images/index/hy_word.png" alt v-if="items.type == 'word'" />
                          <img src="../../assets/images/index/hy_pdf.png" alt v-else-if="items.type == 'pdf'" />
                          <img src="../../assets/images/index/hy_ppt.png" alt v-else-if="items.type == 'ppt'" />
                          <img src="../../assets/images/index/hy_zip.png" alt v-else />
                        </div>
                        <div class="textbox">
                          <h5>{{items.title}}</h5>
                          <p>{{(items.size/1024).toFixed(2)}}MB</p>
                        </div>
                        <div class="hy_zlbtn" v-if="items.is_buy">
                          <a href="javascript:;" @click="downfile(items.id)">
                            <span class="iconfont">&#xe703;</span> 下载
                          </a>
                        </div>
                      </li>
                    </ul>
                    <!--  <a href="javascript:;" class="getMore" v-if="filebox.getFilebtn" @click="getMoreDown(index)">
                加载更多
                <span class="iconfont get_more_icon_all">&#xe699;</span>
                             </a>
                <a href="javascript:;" class="getMore" v-else>
                没有了
                             </a>-->
                  </div>
                </div>
                <!--视频-->
                  <div class="info_item info_video" v-else-if="itembox.type == 11">
                  <h5>{{itembox.title}}</h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items, index) in itembox.list_info" :key="index" @click="videoPlay(items.id)">
                        <div class="imgbox">
                          <img :src="itembox.video_cover_url" alt />
                          <span class="iconfont icon">&#xe696;</span>
                        </div>
                        <div class="textbox" v-if="items.info">
                          <h5>
                            <a href="/">{{items.title}}</a>
                          </h5>
                          <p class="time">{{items.create_time,'Y-M-D h:m'|formatDates}} 时长：{{items.duration}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!--资讯-->
                <div class="info_item info_list" v-else-if="itembox.type == 9">
                  <h5>{{itembox.title}}</h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items,index3) in itembox.list_info" :key="index3">
                        <div class="imgbox">
                          <img :src="items.uploadImgId_url" alt @click="goHref(i,index3)" />
                        </div>
                        <div class="textbox">
                          <h5 @click="goHref(i,index3)">
                            {{items.name}}
                          </h5>
                          <p class="time">{{items.author}} {{items.release_time,'Y-M-D h:m'|formatDates}}</p>
                          <div class="hy_bottom">
                            <p class="num">{{items.click_volume}}人已看</p>
                            <a href="javascript:;" class="hy_zanBtn active iconfont" @click="newsDigg(items.id,i,index3)">
                              &#xe607;
                              <span>{{items.count}}</span>
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!--嘉宾-->
                <div class="info_item info_jiabin" v-else-if="itembox.type == 5">
                  <h5>
                    {{itembox.title}}
                    <router-link class="link" :to="{ name: 'peopleList', params: { id: id }}">查看更多 ></router-link>
                  </h5>
                  <div class="info_item_list">
                    <ul>
                      <li v-for="(items,index3) in itembox.list_info" :key="index3" @click="goPeopleInfo(i,index3)">
                        <template v-if="index3 < 6">
                          <router-link class="links" :to="{ name: 'peopleInfo', params: { id: items.id }}">
                            <div class="imgbox">
                              <img :src="items.head_img" alt />
                            </div>
                            <h5 class="hy_name">{{items.name}}</h5>
                            <p class="hy_type">{{items.domain}}</p>
                            <p class="hy_jigou" v-html="items.description"></p>
                          </router-link>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
            </template>
          </van-tab>
        </van-tabs>
        <!--<div class="info_item info_lianxi" v-if="postsData.conference">
          <h5>联系我们</h5>
          <div class="lianxi_text">
            <p>联系人：{{postsData.conference.contact_name}}</p>
            <p>电话：{{postsData.conference.tel}}</p>
            <p>地址：{{postsData.conference.contact_address}}</p>
          </div>
        </div>-->
      </div>
    </div>
   <!--  <template v-if="postsData.ticket.data.length == 0">
    <div class="info-xingqu">
      <a class="link" :class="postsData.is_like ? 'no_hui':''" @click="ganxingqu()">{{postsData.is_like ? '取消报名':'感兴趣'}}</a>
      </div>
    </template>-->
    <template v-if="postsData.conference.status_str == '报名中'">
      <div class="info-baomingBtn" v-if="(postsData.conference.parallel == 0 ) || (postsData.conference.parallel == 1 &&  postsData.conference.independent == 1)">
        <a class="link" @click="goBaoming()">我要报名</a>
      </div>
    </template>
    <template v-else-if="qrCode">
      <div class="info-baomingBtn">
        <a class="link" @click="goBaoming()">我要报名</a>
      </div>
    </template>

    <!--视频播放-->
    <div class="info_videobox" v-if="videoSet.open">
      <div class="info_play">
        <video id="video1" style="object-fit:cover; object-position: center center;" x-webkit-airplay="" playsinline="" webkit-playsinline="" x5-video-player-type="h5-page" x5-video-player-fullscreen="false" :src="videoSet.video_url" class="v1" muted controls></video>
        <span class="iconfont closeVideobox" @click="closeVideobox()">&#xe629;</span>
      </div>
    </div>
    <!--底部按钮-->
<footerFixed :id="id" :jump-page="postsData.conference.jump_page"/>
  </div>
</template>
<script>
  import {
    formatDates
  } from '@/assets/js/date.js';
  import footerFixed from  '@/components/common/fixed_setting'
  import {
    getCookie,
    delCookie,
    setCookie
  } from '../../http/util'; // cookie操作
  //百度地图
  import {BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker,BmInfoWindow} from 'vue-baidu-map'
  export default {
    components: {
      BaiduMap,
      BmControl,
      BmView,
      BmAutoComplete,
      BmLocalSearch,
      BmMarker,
      BmInfoWindow,
      footerFixed
    },
    data() {
      return {
        id: "",
        active:0,
        lmActive:0,
        footerNav: false,
        postsData: {
          banner: [],
          conference:'',
          column: [],
          guest: {
            guest_infos: []
          },
          is_free: true,
          video: [],
          news: [],
          file: [],
          ticket:{
            data:[]
          },
          is_like:false,
        },
        thisStatus: 0,
        filebox: {
          getFilebtn: true,
          page: 2,
          pagesize: 3
        },
        videoSet: {
          open: false,
          video_url: ''
        },
        center: {lng:116.440424,lat:39.920019},
        zoom: 20,
        mapStyle: {
          width: '100%',
          height: '250px',
          margin: '10px 0px 20px'
        },
        qrCode:'',//线下报名用
      };
    },
    created() {
      this.id = this.$route.params.id;
      if(this.$route.query.qrCode != null){
        localStorage.setItem("qrCode",this.$route.query.qrCode);
      }
      if(localStorage.getItem("qrCode")){
        this.qrCode = localStorage.getItem("qrCode");
      }
      this.list();
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        overlay:true,
        duration:0
      });
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      //锚点跳转
      goAnchor(selector) {
        var anchor = this.$el.querySelector(selector)
        document.documentElement.scrollTop = anchor.offsetTop
      },
      //储存本地作者信息
      goPeopleInfo(i, n) {
        var _this = this;
        localStorage.setItem('guest', JSON.stringify(_this.postsData.column[i].list_info[n]));
      },
      goPeopleInfo2(i, n,s) {
        var _this = this;
        localStorage.setItem('guest', JSON.stringify(_this.postsData.column[i].child[n].list_info[s]));
      },
      //视频播放
      videoPlay(id) {
        var _this = this;
        let url = "/ac1/conference/resource/videoUrl";
        let params = {
          id: id,
          conference_id: _this.id
        };
        _this.$get(url, params).then(res => {
          console.log(res);
          if (res.posts.is_buy) {
            _this.videoSet.video_url = res.posts.url;
            _this.videoSet.open = true;
            setTimeout(function() {
              var video = document.getElementById("video1");
              video.play();
            }, 2000)
          } else {
            _this.$toast('购买门票后可观看该视频资料');
          }
        });

      },
      /*关闭视频弹出*/
      closeVideobox() {
        var _this = this;
        _this.videoSet.open = false;
        setTimeout(function() {
          var video = document.getElementById("video1");
          video.pause(); //暂停控制
        }, 1000)
      },
      //资讯点赞
      newsDigg(id, i, n) {
        var _this = this;
        let url = "/resource/diggrs";
        let params = {
          'resource_id': id,
          resource_type: 3
        };
        _this.$post(url, params).then(res => {
          //  console.log(res);
          var datas = res.posts;
          if (datas == 1) {
            _this.postsData.column[i].list_info[n].count += 1;
          } else if (datas == '0') {
            _this.postsData.column[i].list_info[n].count -= 1;
          }
        });
      },
      newsDigg2(id, i, n,s) {
        var _this = this;
        let url = "/resource/diggrs";
        let params = {
          'resource_id': id,
          resource_type: 3
        };
        _this.$post(url, params).then(res => {
          //  console.log(res);
          var datas = res.posts;
          if (datas == 1) {
            _this.postsData.column[i].child[n].list_info[s].count += 1;
          } else if (datas == '0') {
            _this.postsData.column[i].child[n].list_info[s].count -= 1;
          }
        });
      },
      //资讯跳转
      goHref(i, n) {
        var _this = this;
        var box = _this.postsData.column[i].list_info[n]
        if (box.jump_status == 1) {
          window.location.href = box.jump_link;
        } else {
          _this.$router.push({
            name: 'newinfoPage',
            params: {
              id: box.id
            }
          });
        }
      },
      //资讯跳转
      goHref2(i, n,s) {
        var _this = this;
        var box = _this.postsData.column[i].child[n].list_info[s]
        if (box.jump_status == 1) {
          window.location.href = box.jump_link;
        } else {
          _this.$router.push({
            name: 'newinfoPage',
            params: {
              id: box.id
            }
          });
        }
      },
      //下载方法
      downfile(id) {
        var _this = this;
        let url = "/ac1/conference/fileDownload?id=" + id;
        window.location.href = url;
      },
      //会议资料分页
      getMoreDown(i) {
        var _this = this;
        let url = "/ac1/conference/filePaging";
        let params = {
          id: _this.id,
          page: _this.filebox.page,
          pagesize: _this.filebox.pagesize,
          c_id: _this.postsData.column[i].id
        };
        _this.$get(url, params).then(res => {
          console.log(res);
          _this.filebox.page = parseInt(_this.filebox.page) + 1;
          var datas = res.posts;
          var filellist = JSON.parse(JSON.stringify(_this.postsData.column[i].list_info));
          if (datas.length == _this.filebox.pagesize) {
            _this.postsData.column[i].list_info = filellist.concat(datas);
          } else {
            _this.postsData.column[i].list_info = filellist.concat(datas);
            _this.filebox.getFilebtn = false;
          }
        });
      },
      //banner跳转方法
      goPath(path) {
        if (path == "") {
          return false;
        }
        // this.$router.push(path);
        window.location.href = path;
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      list() {
        var _this = this;
        let url = "/ac1/conference/confDetail";
        let params = {
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          console.log(res);
          if(res.code == 2026){
            this.$router.push('/power');
          }
          var boxdata = res.posts.data;
          _this.center.lng =  boxdata.conference.longitude;
          _this.center.lat =  boxdata.conference.latitude;
          _this.postsData.banner.push({
            pic_url: boxdata.conference.cover_url,
            url: ""
          });
          _this.postsData.conference = boxdata.conference;
          _this.postsData.column = boxdata.column;
          _this.postsData.guest = boxdata.guest;
          _this.postsData.is_free = boxdata.is_free;
          _this.postsData.news = boxdata.news;
          _this.postsData.file = boxdata.file;
          _this.postsData.video = boxdata.video;
          _this.postsData.ticket = boxdata.ticket;
          _this.postsData.is_like = boxdata.is_like;
          if (boxdata.conference.status_str == '报名中') {
            _this.thisStatus = 0;
          } else {
            _this.thisStatus = 1;
          }
          var share_box = res.posts.share_info;
          var wxShareInfo = {
            title: share_box.title,
            info: share_box.desc,
            shareurl: share_box.link,
            img: share_box.img
          };
          var shareData = {
            data: wxShareInfo, //分享配置信息
            ifshare: true,
            that: _this
          };
          sessionStorage.setItem('hy_shareData' + _this.id, JSON.stringify(wxShareInfo));
          _this.$WXConfig.wxShowMenu(shareData);
          this.$toast.clear();
        });
      },
      isMobile() {
        var _this = this;
        var flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if(flag === null) {
          console.log("pc端");
          _this.$dialog.confirm({
            titl: '跳转提示',
            message: '报名会议需要先登录账号 (如果您还不是帐号请先注册)',
            confirmButtonText:'登录',
          })
            .then(() => {
            // on confirm
            window.location.href = "/login/login.html?request_url=" + encodeURIComponent(window.location.href)+'&nologo=1&sitetype=3&siteid=7';
          })
            .catch(() => {
            // on cancel
          });
        }else {
          console.log("移动端");
          window.location.href = "/login/login.html?request_url=" + encodeURIComponent(window.location.href)+'&nologo=1&sitetype=3&siteid=7';
        }
      },
      goBaoming() {
        var _this = this;
        var tokens = getCookie('member_token');
        if (tokens === null) {
          this.isMobile();
        } else {
          let url = '/member/reauth';//刷新token授权
          let params = {};
          _this.$get(url, params).then(res => {
            if(res.code == 1){
              setCookie("member_token",res.posts.token);
              this.$router.push('/enroll01/' + _this.id);
            }else{
              this.isMobile();
            }
          },function(res){
            _this.$toast(res.msg);
          });
        }
      },
      getClickInfo(e){
        var _this = this;
        _this.$dialog.confirm({
          titl: '跳转提示',
          message: '即将跳转到第三方地图，点击确认跳转',
        })
          .then(() => {
          // on confirm
            const a = document.createElement('a') // 创建a标签
            a.setAttribute('href', '')// href链接
            a.setAttribute('target', '')// target属性  打开一个新窗口   好像只有在电脑端调试时有用，手机上无效
              //百度地图
            a.href = "http://api.map.baidu.com/geocoder?location="+ e.point.lat+","+e.point.lng+"&coord_type=bd09ll&output=html&src=webapp.baidu.openAPIdemo";
            a.click()// 自执行点击事件
        })
          .catch(() => {
          // on cancel
        });
      },
      syncCenterAndZoom (e) {
        // debugger
        /*const {lng, lat} = e.target.getCenter()//地图当前的经纬度
        this.center.lng = lng
        this.center.lat = lat
        this.zoom = e.target.getZoom()//地图当前的缩放比例*/
      },
      ganxingqu(){
        var _this = this;
        let url = "/ac1/conference/MemberLike";
        let params = {
          id: _this.id,
        };
        if(_this.postsData.is_like == true){
          _this.$dialog.confirm({
            title: '提示',
            message: '是否确认取消报名?',
          })
            .then(() => {
            // on confirm
            _this.$post(url, params).then(res => {
              if (res.code == 1) {
                if(res.posts == 1){
                  _this.postsData.is_like = true;
                  _this.$toast('报名成功！');
                }else if(res.posts == 2){
                  _this.postsData.is_like = false;
                  _this.$toast('取消成功！');
                }
              } else {
                _this.$toast(res.msg);
              }
            }).catch(err => {
              _this.loading = false;
              _this.$toast('网络错误，请稍后再试');
            });
          })
            .catch(() => {
            // on cancel
            return false;
          });
        } else{
          _this.$post(url, params).then(res => {
            if (res.code == 1) {
              if(res.posts == 1){
                _this.postsData.is_like = true;
                _this.$toast('报名成功！');
              }else if(res.posts == 2){
                _this.postsData.is_like = false;
                _this.$toast('取消成功！');
              }
            } else {
              _this.$toast(res.msg);
            }
          }).catch(err => {
            _this.loading = false;
            _this.$toast('网络错误，请稍后再试');
          });
        }
      }
    }
  };
</script>
<style lang="less">
  .info-listbox {
    width: 100%;
    .van-tabs{
      >div{
        .van-sticky{
          margin-bottom: 20px;
        }
      }
      .van-tabs__line{
        background-color: #2b68da;
      }
    }
    .yiji{
      >.van-tabs__wrap{
        >.van-tabs__nav{
          .van-tabs__line{
            background-color: transparent;
            &:after{
              content: '';
              width: 0px;
              height: 0px;
              border: 15px solid;
              border-color: transparent transparent #028aff;
              position: absolute;
              bottom: 0px;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }
    }
    .erji{
      .van-tabs__wrap{
        border:1px solid #ebebeb;
        border-radius: 10px;
      }
    }
  }
</style>
<style scoped>
  @import '../../assets/css/layui.css';

  .info_textinfobox .info_item_text>>>p {
    font-size: 28px;
    color: #333;
    line-height: 40px;
    text-align: left;
  }

  .info_textinfobox .info_item_text>>>img {
    max-width: 100%;
    height: auto!important;
    display: block;
    margin: 10px auto;
  }
</style>
<style lang="less" scoped>
  //详情页版块样式
  .hy-info {
    width: 100%;
    min-height: 100vh;
    background: #f7f7f7;

    &.baoming {
      padding-bottom: 100px;
    }

    .info-bannerbox {
      width: 100%;
      position: relative;

      .my-swipe {
        width: 100%;

        .van-swipe-item {
          color: #fff;
          width: 100%;
          text-align: center;
          background-color: #fff;
        }

        .van-swipe__indicator {
          width: 8px;
          height: 8px;
          background-color: rgba(255, 255, 255, 0.85);
          opacity: 0.3;

          &.van-swipe__indicator--active {
            width: 20px;
            border-radius: 4px;
            background: #fff;
            opacity: 1;
          }
        }
      }
    }

    .info-cont {
      width: 100%;

      .info-topTitle {
        width: 100%;
        background: #fff;
        padding: 30px;
        margin-bottom: 20px;

        .title {
          width: 100%;
          overflow: hidden;

          h5 {
            font-size: 32px;
            color: #141313;
            float: left;
            width: 580px;
            text-align: left;
            line-height: 40px;
          }

          .info_icon {
            float: right;
            padding: 1px 15px;
            background: #e8f6fc;
            color: #3cb7ff;
            font-size: 22px;
            line-height: 36px;
            border-radius: 18px;
          }
        }

        .info_info {
          font-size: 28px;
          color: #141313;
          line-height: 40px;
          text-align: left;
          margin: 15px 0px;
        }

        .infotimes {
          width: 100%;
          overflow: hidden;
          font-size: 26px;
          color: #8e8e8e;
          text-align: left;
          line-height: 50px;

          .iconfont {
            font-size: 32px;
            float: left;
            margin-right: 10px;
          }
          .label{
            display: inline-block;
            width: 170px;
            white-space: nowrap;
          }
          .content {
            display: inline-block;
            width: calc(100% - 170px);
            white-space: wrap;
          }
        }
        .infotimes_width_label_content{
          display: flex;
          align-items: flex-start;
          .label{
              min-width: 174px;
              white-space: nowrap;
            }
        }

        .infoBtnBox {
          width: 100%;
          overflow: hidden;
          margin-top: 10px;
          text-align: left;

          .infoBtn {
            float: left;
            display: block;
            line-height: 40px;
            font-size: 26px;
            color: #fff;
            padding: 0 10px;
            border-radius: 5px;
            margin-right: 10px;
          }

          p {
            font-size: 26px;
            color: #8e8e8e;
            text-align: left;
            line-height: 40px;
          }

          &.icon_yellow {
            .infoBtn {
              background: #ff5d34;
            }

            p {
              color: #ff5d34;
            }
          }

          &.icon_blue {
            .infoBtn {
              background: #0d55da;
            }

            p {
              color: #0d55da;
            }
          }

          &.icon_black {
            .infoBtn {
              background: #333;
            }

            p {
              color: #8e8e8e;
            }
          }
        }
      }

      .info-listbox {
        width: 100%;
        .van-tabs{
          >div{
            .van-sticky{
              margin-bottom: 20px;
            }
          }
        }
        .tabList{
          width: 100%;
          margin: 0 auto 20px;
          padding: 20px 20px 20px;
          background: #FFF;
          white-space: nowrap;
          overflow-y: scroll;
          a{
            font-size: 30px;
            margin: 0 20px;
            color: #333;
          }
        }
        .info_item {
          width: 100%;
          background: #fff;
          padding: 30px;
          margin-bottom: 20px;

          >h5 {
            font-size: 32px;
            font-weight: 600;
            line-height: 45px;
            color: #333333;
            display: inline-block;
            text-align: left;
            padding: 0 10px;
            position: relative;
            background-image: url(../../assets/images/index/hy_titlebg.png);
            background-position: left center;
            background-repeat: no-repeat;
            background-size: 155px auto;
            overflow: hidden;
            width: 100%;

            a {
              float: right;
              font-size: 26px;
              color: #a3a3a3;
              font-weight: 400;
            }
          }

          >div {
            ul {
              width: 100%;
            }
          }

          &.info_downlist {
            .info_item_list {
              width: 100%;

              ul {
                width: 100%;

                li {
                  width: 100%;
                  overflow: hidden;
                  padding: 30px 0px;
                  border-bottom: 1px solid #ebebeb;

                  .imgbox {
                    width: 85px;
                    height: 110px;
                    position: relative;
                    float: left;
                    margin-right: 20px;

                    img {
                      width: 100%;
                      height: 100%;
                    }
                  }

                  .textbox {
                    width: 370px;
                    float: left;

                    h5 {
                      width: 100%;
                      overflow: hidden;
                      font-size: 28px;
                      color: #333;
                      line-height: 30px;
                      max-height: 60px;
                    }

                    p {
                      font-size: 24px;
                      color: #9d9d9d;
                      line-height: 45px;
                    }
                  }

                  .hy_zlbtn {
                    width: 150px;
                    height: 70px;
                    float: right;
                    margin: 20px 0px;

                    a {
                      display: block;
                      width: 100%;
                      height: 100%;
                      border: 1px solid #2b68da;
                      color: #2b68da;
                      font-size: 26px;
                      line-height: 70px;
                      border-radius: 35px;
                      text-align: center;

                      span {
                        font-size: 35px;
                        vertical-align: middle;
                      }
                    }
                  }
                }
              }
            }
          }

          &.info_video {
            .info_item_list {
              padding: 20px 0px;

              ul {
                width: 100%;

                li {
                  width: 100%;
                  overflow: hidden;
                  margin-bottom: 15px;

                  .imgbox {
                    float: left;
                    width: 210px;
                    height: 140px;
                    position: relative;
                    margin-right: 20px;

                    img {
                      width: 100%;
                      height: 100%;
                      display: block;
                    }

                    .icon {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      width: 40px;
                      height: 40px;
                      font-size: 50px;
                      line-height: 40px;
                      color: #fff;
                      text-align: center;
                      margin: -20px 0 0 -20px;
                    }
                  }

                  .textbox {
                    width: 450px;
                    height: 140px;
                    float: left;
                    position: relative;

                    h5 {
                      line-height: 40px;
                      max-height: 80px;
                      overflow: hidden;
                      font-size: 28px;
                      color: #333;
                    }

                    .time {
                      font-size: 24px;
                      color: #8e8e8e;
                      line-height: 35px;
                      position: absolute;
                      bottom: 0px;
                    }
                  }
                }
              }
            }
          }

          &.info_list {
            .info_item_list {
              padding: 0px 0px;

              ul {
                width: 100%;

                li {
                  width: 100%;
                  overflow: hidden;
                  border-bottom: 1px solid #ebebeb;
                  padding: 20px 0px;

                  .imgbox {
                    float: left;
                    width: 210px;
                    height: 140px;
                    position: relative;
                    margin-right: 20px;

                    img {
                      width: 100%;
                      height: 100%;
                      display: block;
                    }
                  }

                  .textbox {
                    width: 450px;
                    height: 140px;
                    float: left;
                    position: relative;

                    h5 {
                      line-height: 35px;
                      height: 70px;
                      overflow: hidden;
                      font-size: 28px;
                      color: #333;
                    }

                    .time {
                      font-size: 24px;
                      color: #8e8e8e;
                      line-height: 35px;
                    }

                    .hy_bottom {
                      width: 100%;
                      font-size: 24px;
                      color: #8e8e8e;
                      line-height: 20px;
                      overflow: hidden;

                      .num {
                        float: left;
                        font-size: 24px;
                        color: #8e8e8e;
                        line-height: 35px;
                      }

                      .hy_zanBtn {
                        float: right;
                        font-size: 24px;
                        color: #8e8e8e;
                        line-height: 35px;

                        &.active {
                          color: #fd882b;
                        }
                      }
                    }
                  }

                  &:last-child {
                    border: none;
                  }
                }
              }
            }
          }

          &.info_textinfobox {
            .info_item_text {
              width: 100%;
              padding: 15px 0px;
              font-size: 28px;
              color: #333;
              line-height: 40px;

              p {
                font-size: 28px;
                color: #333;
                line-height: 40px;
                text-indent: 2em;
              }

              img {
                max-width: 100%;
                display: block;
                margin: 10px auto;
              }
            }
          }

          &.info_jiabin {
            .info_item_list {
              padding-bottom: 30px;

              ul {
                width: 100%;
                overflow: hidden;

                li {
                  width: 33%;
                  float: left;
                  text-align: center;
                  padding: 0 10px;
                  margin-top: 40px;

                  a {
                    .imgbox {
                      width: 140px;
                      height: 140px;
                      border-radius: 50%;
                      overflow: hidden;
                      margin: 0 auto;
                      transition: all 0.2s;
                      border: 1px solid #ebebeb;

                      img {
                        width: 100%;
                        height: 100%;
                      }
                    }

                    .hy_name {
                      width: 100%;
                      font-size: 30px;
                      color: #333;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      line-height: 45px;
                      font-weight: 600;
                    }

                    .hy_type {
                      width: 100%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      font-size: 22px;
                      color: #fd882b;
                      line-height: 40px;
                      min-height: 40px;
                    }

                    .hy_jigou {
                      width: 100%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      font-size: 22px;
                      color: #9b9b9b;
                      line-height: 40px;
                    }
                  }
                }
              }
            }
          }

          &.info_lianxi {
            .lianxi_text {
              width: 100%;
              padding: 20px 0px;

              p {
                font-size: 28px;
                line-height: 50px;
                color: #333;
              }
            }
          }
        }
      }
    }

    //报名按钮
    .info-baomingBtn {
      position: fixed;
      bottom: 0px;
      left: 50%;
      z-index: 2000;
      width: 100%;
      height: 100px;
      max-width: 750px;
      margin-left: -375px;

      a {
        width: 100%;
        height: 100%;
        display: block;
        background: #ff7a58;
        color: #fff;
        text-align: center;
        line-height: 100px;
        font-size: 30px;
      }
    }
    .info-xingqu{
      position: fixed;
      bottom: 0px;
      left: 50%;
      z-index: 2000;
      width: 100%;
      height: 100px;
      max-width: 750px;
      margin-left: -375px;

      a {
        width: 100%;
        height: 100%;
        display: block;
        background: #ff7a58;
        color: #fff;
        text-align: center;
        line-height: 100px;
        font-size: 30px;
        &.no_hui{
          background: #bdbdbd;
        }
      }
    }
    .info_videobox {
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0px;
      left: 50%;
      z-index: 10000;
      background: rgba(0, 0, 0, .5);
      max-width: 750px;
      margin-left: -375px;

      .info_play {
        width: 90vw;
        height: 500px;
        position: relative;
        top: 40%;
        left: 5vw;
        margin-top: -250px;
        background: rgba(0, 0, 0, .6);

        video {
          width: 100%;
          height: 100%;
        }

        .closeVideobox {
          position: absolute;
          bottom: -70px;
          left: 50%;
          font-size: 30px;
          background: #FFF;
          display: block;
          width: 50px;
          height: 50px;
          text-align: center;
          line-height: 55px;
          border-radius: 50%;
          margin-left: -25px;
        }
      }
    }
  }
</style>
